export const ANONYMOUS_SENDER_NAME = 'Anonymous'
export const ANONYMOUS_RECIPIENT_NAME = 'Gift Recipient'
